const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

export function toPersianDigits(value) {
  return toAsciiDigits(value).replace(/\d/g, digit => PERSIAN_DIGITS[Number(digit)]);
}

export function toAsciiDigits(value) {
  return String(value ?? '')
    .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660));
}

export function parseNumericInput(value) {
  const normalized = toAsciiDigits(value);
  if (normalized === '') return {valid: true, value: ''};
  if (!/^[0-9.,،٬٫]+$/.test(normalized)) return {valid: false};
  const decimalMarks = normalized.match(/[.٫]/g) || [];
  if (decimalMarks.length > 1) return {valid: false};
  const hasDecimal = decimalMarks.length === 1;
  const [integerPart, fractionPart = ''] = hasDecimal ? normalized.split(decimalMarks[0]) : [normalized, ''];
  if (!integerPart || (hasDecimal && !/^\d*$/.test(fractionPart))) return {valid: false};
  const groupingMarks = integerPart.match(/[,،٬]/g) || [];
  let integerDigits = integerPart;
  if (groupingMarks.length) {
    const separator = groupingMarks[0];
    if (groupingMarks.some(mark => mark !== separator)) return {valid: false};
    const groups = integerPart.split(separator);
    if (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some(group => !/^\d{3}$/.test(group))) return {valid: false};
    integerDigits = groups.join('');
  } else if (!/^\d+$/.test(integerPart)) return {valid: false};
  return {valid: true, value: integerDigits + (hasDecimal ? `.${fractionPart}` : '')};
}

export function numericDisplay(value, focused = false) {
  if (value === '' || value === null || value === undefined) return '';
  const canonical = toAsciiDigits(value);
  const match = canonical.match(/^(\d+)(\.(\d*))?$/);
  if (!match) return toPersianDigits(canonical);
  const integer = focused ? match[1] : match[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return toPersianDigits(integer) + (match[2] ? `٫${toPersianDigits(match[3])}` : '');
}
